module.exports = __webpack_public_path__ + "media/images/Icon-eye-0b185802d3cfa0bf6fadbafa3540223a.svg";